/** "3000.5" from a stored number; empty for 0/undefined so the placeholder shows. */
export const amountToInput = (amount?: number | null) => {
  if (!amount) return "";
  const [integer, decimals] = amount.toFixed(2).split(".");
  return decimals === "00" ? integer : `${integer}.${decimals}`;
};
